var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3679_101036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4277 35.6801C28.2588 35.6801 36.2284 27.7104 36.2284 17.8793C36.2284 8.04827 28.2588 0.0786133 18.4277 0.0786133C8.59661 0.0786133 0.626953 8.04827 0.626953 17.8793C0.626953 27.7104 8.59661 35.6801 18.4277 35.6801Z",
    fill: "#17181D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4112 17.8796L10.4241 22.5865L14.4236 24.94V27.6957L8.08346 23.9773V16.5032L10.4112 17.8796ZM10.4112 13.1727V15.9156L8.08203 14.5377V11.7948L10.4112 10.417L12.7519 11.7948L10.4112 13.1727ZM16.0938 11.7948L18.423 10.417L20.7637 11.7948L18.423 13.1727L16.0938 11.7948Z",
    fill: "#F1B90C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0957 21.6109V18.8552L14.4249 20.2331V22.976L12.0957 21.6109ZM16.0951 25.9271L18.4243 27.3048L20.765 25.9271V28.6699L18.4243 30.0477L16.0951 28.6699V25.9271ZM24.1054 11.7948L26.4347 10.417L28.7753 11.7948V14.5377L26.4347 15.9156V13.1727L24.1054 11.7948ZM26.4347 22.5865L26.4475 17.8796L28.7767 16.5017V23.9757L22.4366 27.6943V24.9386L26.4347 22.5865Z",
    fill: "#F1B90C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7648 21.6111L22.4355 22.9761V20.2332L24.7648 18.8555V21.6111Z",
    fill: "#F1B90C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7644 14.1477L24.7773 16.9034L20.7664 19.2569V23.9753L18.4372 25.3402L16.1079 23.9753V19.2569L12.0971 16.9034V14.1477L14.4363 12.7699L18.4229 15.1348L22.4338 12.7699L24.7745 14.1477H24.7644ZM12.0957 9.44224L18.4243 5.71094L24.7644 9.44224L22.4352 10.8201L18.4243 8.45521L14.4249 10.8201L12.0957 9.44224Z",
    fill: "#F1B90C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3679_101036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.6015,
    height: 35.6015,
    fill: "white",
    transform: "translate(0.626953 0.0786133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/BSC.7593d081867ec515f71b903b7be6824f.svg";
export { ForwardRef as ReactComponent };